(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var drawer = $('#CartDrawer');
  var moneyFormat = (drawer && drawer.getAttribute('data-money-format')) || '${{amount}}';
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var withComma = v.replace('.', ',');
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
  var lastFocus = null;
  function openCart() {
    lastFocus = document.activeElement;
    document.documentElement.classList.add('cd-open');
    if (drawer) { drawer.setAttribute('aria-hidden', 'false'); var c = $('[data-cart-close]', drawer); if (c) c.focus(); }
    refreshCart();
  }
  function closeCart() {
    document.documentElement.classList.remove('cd-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = n; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cd-empty"><p style="font-family:Manrope,sans-serif;font-weight:800;font-size:18px">Your cart is empty</p><a class="btn btn-primary" href="' + root + 'products/lock-and-lift-strapless-bra">SHOP THE BRA</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).map(function (o) { return '<p style="font-size:14px;color:#7A6B72">' + esc(o.name) + ': ' + esc(o.value) + '</p>'; }).join('');
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var save = it.original_line_price > it.final_line_price;
      var tags = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="tag">' + esc(d.discount_application.title) + '</span>'; }).join('');
      return '<div class="cd-item" data-line="' + (i + 1) + '">' +
        (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
        '<div style="display:flex;flex-direction:column;gap:6px;min-width:0">' +
          '<div style="display:flex;justify-content:space-between;gap:8px"><a href="' + it.url + '" style="font-family:Manrope,sans-serif;font-weight:800;font-size:16px;color:#171317;text-decoration:none;line-height:1.3">' + esc(it.product_title) + '</a>' +
          '<button class="cd-remove" type="button" data-remove="' + (i + 1) + '" aria-label="Remove ' + esc(it.title) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button></div>' +
          opts +
          '<div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:6px">' +
            '<div class="qty"><button type="button" data-qty="' + (i + 1) + '" data-val="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (i + 1) + '" data-val="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
            '<div style="text-align:right;line-height:1.35">' +
              (save ? '<s style="color:#7A6B72;font-size:14px">' + money(it.original_line_price) + '</s> ' : '') +
              '<strong style="font-size:16px">' + money(it.final_line_price) + '</strong>' +
              (save ? '<div style="color:#A02C4B;font-weight:700;font-size:14px">(Save ' + money(it.original_line_price - it.final_line_price) + ')</div>' : '') +
              (tags ? '<div style="margin-top:4px">' + tags + '</div>' : '') +
            '</div>' +
          '</div>' +
        '</div></div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      var disc = cart.total_discount || 0;
      var dRow = $('[data-cart-discount-row]', foot);
      dRow.hidden = !disc;
      if (disc) {
        var titles = (cart.cart_level_discount_applications || []).map(function (d) { return d.title; });
        cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (d) { if (titles.indexOf(d.discount_application.title) < 0) titles.push(d.discount_application.title); }); });
        $('[data-cart-discount-title]', foot).textContent = titles.join(', ');
        $('[data-cart-discount]', foot).textContent = '- ' + money(disc);
      }
      $('[data-cart-total]', foot).textContent = money(cart.total_price);
    }
  }
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function changeLine(line, qty) {
    if (drawer) drawer.classList.add('cd-loading');
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(renderCart)
      .finally(function () { if (drawer) drawer.classList.remove('cd-loading'); });
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () { openCart(); });
  }
  window.LV = { openCart: openCart, closeCart: closeCart, addItems: addItems, money: money, $: $, $$: $$, esc: esc };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var q = e.target.closest('[data-qty]');
    if (q) { changeLine(+q.getAttribute('data-qty'), +q.getAttribute('data-val')); return; }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(+rm.getAttribute('data-remove'), 0); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.documentElement.classList.contains('cd-open')) closeCart();
  });

  $$('[data-slider]').forEach(function (s) {
    var track = $('.track', s), cards = $$('.card', track), prev = $('[data-prev]', s), next = $('[data-next]', s), i = 0;
    function perView() {
      var vp = $('.viewport', s);
      if (!cards[0] || !vp) return 1;
      return Math.max(1, Math.round(vp.clientWidth / (cards[0].getBoundingClientRect().width + 14)));
    }
    function update() {
      var max = Math.max(0, cards.length - perView());
      i = Math.min(Math.max(0, i), max);
      track.style.setProperty('--i', i);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= max;
    }
    if (prev) prev.addEventListener('click', function () { i--; update(); });
    if (next) next.addEventListener('click', function () { i++; update(); });
    window.addEventListener('resize', update);
    update();
  });

  $$('[data-coverflow]').forEach(function (cf) {
    var items = $$('.cf-item', cf), n = items.length, cur = 0, timer;
    var name = $('[data-cf-name]'), text = $('[data-cf-text]');
    function render() {
      var small = window.innerWidth <= 760, step = small ? 150 : 230;
      items.forEach(function (el, i) {
        var d = ((i - cur) % n + n) % n; if (d > n / 2) d -= n;
        var a = Math.abs(d);
        el.style.transform = 'translateX(' + d * step + 'px) translateZ(' + (-a * 170) + 'px) rotateY(' + (-d * 32) + 'deg)';
        el.style.opacity = a > 2 ? 0 : (a === 0 ? 1 : 0.85);
        el.style.zIndex = 10 - a;
        el.setAttribute('aria-current', a === 0 ? 'true' : 'false');
      });
      if (name) name.textContent = items[cur].getAttribute('data-name');
      if (text) text.textContent = items[cur].getAttribute('data-text');
    }
    function go(k) { cur = (k + n) % n; render(); }
    items.forEach(function (el, i) { el.addEventListener('click', function () { go(i); }); });
    var p = $('[data-cf-prev]'), nx = $('[data-cf-next]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    function auto() { clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, 3500); }
    cf.addEventListener('mouseenter', function () { clearInterval(timer); });
    cf.addEventListener('mouseleave', auto);
    window.addEventListener('resize', render);
    render(); auto();
  });

  $$('[data-fader]').forEach(function (f) {
    var slides = $$('[data-slide]', f), dots = $$('[data-dot]', f), cur = 0, timer;
    var num = $('[data-f-num]', f), title = $('[data-f-title]', f), text = $('[data-f-text]', f);
    function go(k) {
      cur = (k + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.style.opacity = i === cur ? 1 : 0; s.style.transform = 'scale(' + (i === cur ? 1 : 1.04) + ')'; });
      dots.forEach(function (d, i) { var dot = $('.dot', d); d.setAttribute('aria-pressed', i === cur); dot.style.width = i === cur ? '32px' : '12px'; dot.style.background = i === cur ? '#6E3854' : '#DEC8D2'; });
      var s = slides[cur];
      if (num) num.textContent = '0' + (cur + 1) + ' / 0' + slides.length;
      if (title) title.textContent = s.getAttribute('data-title');
      if (text) text.textContent = s.getAttribute('data-text');
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, 4500); }); });
    go(0); timer = setInterval(function () { go(cur + 1); }, 4500);
  });

  $$('video[data-autoplay]').forEach(function (v) { v.muted = true; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
})();